import { render } from "./AddFamilleModal.vue?vue&type=template&id=5bda6b3d&ts=true"
import script from "./AddFamilleModal.vue?vue&type=script&lang=ts"
export * from "./AddFamilleModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__